import React, {useContext, useEffect, useState} from 'react';
import FileApi from '../../../../interface/api/file';
import SiteApi from '../../../../interface/api/site';
import {SiteInfo} from "../../../../interface/model/site";
import {FileInfo} from "../../../../interface/model/file";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {HostStateContext} from "../../index";

const ButtonStyle = {
    display: 'inline-block',
    height: '33px',
    padding: '0 15px',
    fontSize: '13px',
    lineHeight: '33px',
    verticalAlign: 'middle',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '5px',
    color:'#fff',
    background: '#3280ff',
    margin:'0 5px'
}

export default function CiManage() {
    const { hostInfo } = useContext(HostStateContext);
    const [ useSiteInfo, setUseSiteInfo ] = useState<SiteInfo>(null);
    const [ pcFileInfo, setPcFileInfo ] = useState<FileInfo>(null);
    const [ mobileFileInfo, setMobileFileInfo ] = useState<FileInfo>(null);
    const [ windowFileInfo, setWindowFileInfo ] = useState<FileInfo>(null);

    function fileOnChange (e){
        let fileArray = new Array();
        let files = e.target.files;
        fileArray.push(files[0]);
        if( e.target.name === 'pcCiFile' ) {
            FileApi.createFileInfo('SITE', fileArray).then(res => {
                setPcFileInfo(res.data);
                SiteApi.updateSiteFileInfo({seq : hostInfo.siteInfo.seq, type : 'PC', fileInfo : res.data});
            });
        } else if( e.target.name === 'mobileCiFile' ) {
            FileApi.createFileInfo('SITE', fileArray).then(res => {
                setMobileFileInfo(res.data);
                SiteApi.updateSiteFileInfo({seq : hostInfo.siteInfo.seq, type : 'MO', fileInfo : res.data});
            });
        } else {
            FileApi.createFileInfo('SITE', fileArray).then(res => {
                setWindowFileInfo(res.data);
                SiteApi.updateSiteFileInfo({seq : hostInfo.siteInfo.seq, type : 'WIN', fileInfo : res.data});
            });
        }

    }

    function saveSiteFooter() {
        SiteApi.updateSiteFooterInfo(hostInfo.siteInfo.seq, useSiteInfo);
    }

    useEffect(() => {
        SiteApi.siteInfoListBySeq(hostInfo.siteInfo.seq).then(res => setUseSiteInfo(res.data));
        if(hostInfo.siteInfo.pcLogo !== undefined && hostInfo.siteInfo.pcLogo !== null) {
            setPcFileInfo(hostInfo.siteInfo.pcLogo);
        }
        if(hostInfo.siteInfo.mobileLogo !== undefined && hostInfo.siteInfo.mobileLogo !== null) {
            setMobileFileInfo(hostInfo.siteInfo.mobileLogo);
        }
        if(hostInfo.siteInfo.windowLogo !== undefined && hostInfo.siteInfo.windowLogo !== null) {
            setWindowFileInfo(hostInfo.siteInfo.windowLogo);
        }
    }, [])

    return (
        <>
            <div className="nv_contents">
                <PcLogoSelect
                    pcFileInfo={pcFileInfo}
                    fileOnChange={fileOnChange}
                />
                <MobileLogoSelect
                    mobileFileInfo={mobileFileInfo}
                    fileOnChange={fileOnChange}
                />
                <WindowImage
                    windowFileInfo={windowFileInfo}
                    fileOnChange={fileOnChange}
                />
            </div>
        </>
    )
}


function PcLogoSelect({pcFileInfo, fileOnChange}) {
    return(
        <>
            <div className="nv_table_tit regist_tit">
                <h4>회사 로고(PC용)</h4>
            </div>
            <div className="nv_table_box nv_table_scroll">
                <dl className="nv_dl_table">
                    <dt>이미지 선택</dt>
                    {
                        pcFileInfo === null
                            ?
                            <dd className="nv_dd_full nv_date nv_double_select adminVersion">
                                <input type="text" className="nv_input max_200" value="" />
                                <input type="file"
                                       id="pcCiFile" name="pcCiFile"
                                       style={{display:"none"}}
                                       onChange={fileOnChange}
                                       required={true}
                                       multiple/>
                                <label htmlFor="pcCiFile" style={ButtonStyle}>
                                    파일선택
                                </label>
                            </dd>
                            :   <dd className="nv_dd_full nv_date nv_double_select adminVersion">
                                <input type="text" className="nv_input max_200" value={pcFileInfo.fileName} />
                                <input type="file"
                                       id="pcCiFile" name="pcCiFile"
                                       style={{display:"none"}}
                                       onChange={fileOnChange}
                                       required={true}
                                       multiple/>
                                <label htmlFor="pcCiFile" style={ButtonStyle}>
                                    파일선택
                                </label>
                            </dd>
                    }
                </dl>
            </div>
        </>
    )
}

function WindowImage({windowFileInfo, fileOnChange}) {
    return (
        <>
            <div className="nv_table_tit regist_tit">
                <h4>방문신청 화면 배경 </h4>
            </div>
            <div className="nv_table_box nv_table_scroll">
                <dl className="nv_dl_table">
                    <dt>이미지 선택</dt>
                    {
                        windowFileInfo === null
                            ?
                            <dd className="nv_dd_full nv_date nv_double_select adminVersion">
                                <input type="text" className="nv_input max_200" value="" />
                                <input type="file"
                                       id="windowCiFile" name="windowCiFile"
                                       style={{display:"none"}}
                                       onChange={fileOnChange}
                                       required={true}
                                       multiple/>
                                <label htmlFor="windowCiFile" style={ButtonStyle}>
                                    파일선택
                                </label>
                            </dd>
                            :   <dd className="nv_dd_full nv_date nv_double_select adminVersion">
                                <input type="text" className="nv_input max_200" value={windowFileInfo.fileName} />
                                <input type="file"
                                       id="windowCiFile" name="windowCiFile"
                                       style={{display:"none"}}
                                       onChange={fileOnChange}
                                       required={true}
                                       multiple/>
                                <label htmlFor="windowCiFile" style={ButtonStyle}>
                                    파일선택
                                </label>
                            </dd>
                    }
                </dl>
            </div>
        </>
    )
}

function MobileLogoSelect({mobileFileInfo, fileOnChange}) {
    return(
        <>
            <div className="nv_table_tit regist_tit">
                <h4>회사 로고(Mobile용)</h4>
            </div>
            <div className="nv_table_box nv_table_scroll">
                <dl className="nv_dl_table">
                    <dt>이미지 선택</dt>
                    {
                        mobileFileInfo===null
                            ?
                            <dd className="nv_dd_full nv_date nv_double_select adminVersion">
                                <input type="text" className="nv_input max_200" value="" />
                                <input type="file"
                                       id="mobileCiFile" name="mobileCiFile"
                                       style={{display:"none"}}
                                       onChange={fileOnChange}
                                       required={true}
                                       multiple/>
                                <label htmlFor="mobileCiFile" style={ButtonStyle}>
                                    파일선택
                                </label>
                            </dd>
                            :   <dd className="nv_dd_full nv_date nv_double_select adminVersion">
                                <input type="text" className="nv_input max_200" value={mobileFileInfo.fileName} />
                                <input type="file"
                                       id="mobileCiFile" name="mobileCiFile"
                                       style={{display:"none"}}
                                       onChange={fileOnChange}
                                       required={true}
                                       multiple/>
                                <label htmlFor="mobileCiFile" style={ButtonStyle}>
                                    파일선택
                                </label>
                            </dd>
                    }
                </dl>
            </div>
        </>
    )
}

function FooterSetting({siteInfo, useSiteInfo, setUseSiteInfo, saveSiteFooter}) {
    const modules = {
        toolbar: [
            //[{ 'font': [] }],
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image'],
            [{ 'align': [] }, { 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            ['clean']
        ],
    }
    
    const formats = [
        //'font',
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image',
        'align', 'color', 'background',        
    ]
    return (
        <>
            <div className="nv_table_tit regist_tit">
                <h4>사이트 하단관리</h4>
            </div>
            <div className="nv_table_box">
                <dl className="nv_dl_table">
                    <dt style={{height:'360px'}}>Footer 관리</dt>
                    <dd className="nv_dd_full" style={{height:'360px'}}>
                        <ReactQuill style={{height: "300px", overflow:'scroll'}}
                            modules={modules}
                            formats={formats}
                            value={siteInfo.footer || ''}
                            onChange={(content, delta, source, editor) => setUseSiteInfo({...useSiteInfo, footer : editor.getHTML()})} />
                        <button type="button" name="saveFooterBtn"
                            className="nv_blue_button btnMargin" style={{float: 'right', marginTop:'10px'}}
                            onClick={saveSiteFooter}>저장</button>
                    </dd>
                </dl>
            </div>
        </>
    )
}